import React, { useState } from 'react';
import { Search, ShoppingCart, Menu, X, ChevronRight, Check, Star, Clock, Shield, Smartphone } from 'lucide-react';


// Footer Component
const Footer = () => {
  const testimonials = [
    { text: "Got my iPhone 15 Pro in 2 hours. Perfect service.", author: "Daniel", type: "Online Customer" },
    { text: "Trusted them with a trade-in. Smooth process and fair value", author: "Tife", type: "Walk-in Customer" },
    { text: "Best tech store I've ordered from in Nigeria.", author: "Aisha", type: "Online Customer" }
  ];

  return (
    <footer className="bg-white border-t border-gray-200">
      {/* Testimonials */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h3 className="text-2xl font-semibold text-center mb-12">What our Customers say</h3>
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6">
              <div className="flex text-yellow-400 mb-3">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
              </div>
              <p className="text-gray-700 mb-4">"{testimonial.text}"</p>
              <p className="font-medium">{testimonial.author}</p>
              <p className="text-sm text-gray-500">{testimonial.type}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Newsletter */}
      <div className="bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-2xl font-semibold mb-4">Stay Ahead of the Drop</h3>
          <p className="text-gray-600 mb-6">Be the first to know when new devices launch or prices drop.</p>
          <div className="flex max-w-md mx-auto gap-2">
            <input 
              type="email" 
              placeholder="Email Address" 
              className="flex-1 px-4 py-3 rounded-full border border-gray-300 outline-none focus:border-black transition"
            />
            <button className="bg-black text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800 transition">
              Join the List
            </button>
          </div>
        </div>
      </div>

      {/* Footer Info */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div>
            <p className="text-gray-600 mb-4">
              Your trusted source for genuine Apple products and premium gadgets. Secure payment. Fast delivery. Real support.
            </p>
            <p className="text-sm text-gray-500">
              Suite D6, Diamond Plaza, Beside UBA Bank<br />
              Computer Village, Ikeja
            </p>
          </div>
          <div className="space-y-2">
            <p className="text-sm">+234 805 998 7568</p>
            <p className="text-sm">+234 902 391 8155</p>
            <p className="text-sm">+234 911 951 2726</p>
          </div>
        </div>
        
        <div className="flex justify-between items-center pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">© Josie Phones & Gadgets Store. All Rights Reserved.</p>
          <div className="flex space-x-4 text-sm">
            <a href="#" className="hover:text-gray-600 transition">Shop</a>
            <a href="#" className="hover:text-gray-600 transition">Trade-in</a>
            <a href="#" className="hover:text-gray-600 transition">Support</a>
            <a href="#" className="hover:text-gray-600 transition">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer